import PageHeading from '@shared/ui/PageHeading';
import { HelpBtn } from '@widgets/buttons';
import TransactionsTable from '@widgets/tables/TransactionsTable';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTransactionsFilters } from '@utils/drawer-hooks';
import { FilterButton, ThemeButtonIcon } from '@shared/ui/buttons';
import {
  resetTransactionsFilters,
  setTransactionsParams,
  setTransactionsSearch,
} from '@app/store/slices/transactionsSlice';
import { useMobileOverlay } from '@utils/hooks/useMobileOverlay';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@utils/libs/theme';
import { SearchTable } from '@shared/ui/forms/search';
import TableMenuBtn from '@widgets/tables/main/TableMenuBtn';

export default function TransactionsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openTransactionsFilters } = useTransactionsFilters();
  const { filtersCount, search } = useSelector((state) => state.transactions);
  const mobileSearch = useMobileOverlay();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    dispatch(setTransactionsParams({ page: 1 }));
  }, []);

  const handleSearchChange = useCallback(
    (nextSearch) => {
      dispatch(setTransactionsSearch(nextSearch));
    },
    [dispatch],
  );

  const filterButtonElement = useMemo(() => {
    return (
      <FilterButton
        onClick={openTransactionsFilters}
        filtersCount={filtersCount}
        resetFilters={resetTransactionsFilters}
      />
    );
  }, [filtersCount, openTransactionsFilters]);

  const searchTableElement = useMemo(() => {
    return (
      <SearchTable
        handleSearch={handleSearchChange}
        value={search}
        placeholder={t('transactions_search_placeholder')}
      />
    );
  }, [handleSearchChange, search, t]);

  return (
    <section className="table-page main-section">
      {isMobile && mobileSearch.isOpen && (
        <div className="search-mobile-container">
          <div className="block-pd-x search-mobile">
            <ThemeButtonIcon icon="arrow-left" onClick={mobileSearch.close} />
            {searchTableElement}
          </div>
        </div>
      )}
      {!mobileSearch.isOpen && (
        <PageHeading title={t('Transactions')}>
          {isMobile && (
            <>
              {filterButtonElement}
              <ThemeButtonIcon icon="search" onClick={mobileSearch.open} />
            </>
          )}
          {!isMobile && (
            <>
              <HelpBtn page="transactions" />
              {/* <ThemeButton
                appearance="secondary"
                startIcon="export"
                block={false}
              >
                Export
              </ThemeButton> */}
            </>
          )}
          {isMobile && <TableMenuBtn menu="transactions" />}
        </PageHeading>
      )}

      <div className="block-pd-x table-page__box">
        {!isMobile && (
          <div className="table-filters table-filters-transactions">
            <div className="table-filters-row">{searchTableElement}</div>
            {filterButtonElement}
          </div>
        )}
        <div className="table-page__table">
          <TransactionsTable />
        </div>
      </div>
    </section>
  );
}
